<template>
    <form class="p-2" @submit.prevent="salva">

        <!-- ======================================================== TESTATA -->
        <div class="flex flex-wrap">
            <div class="md:w-1/4 px-3 my-1 w-full">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" for="bol_contratto">
                    {{ __('Contratto') }}
                </label>
                <select id="bol_contratto" v-model="d.contratto"
                    :class="{'bg-red-400': !d.contratto && inviato}"
                    class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                    <option value="">{{ __('-- scegli --') }}</option>
                    <option v-for="c in contratti" :key="c.contratto" :value="c.contratto">
                        {{ c.contratto }} - {{ c.descrizione }}
                    </option>
                </select>
            </div>
            <div class="md:w-1/4 px-3 my-1 w-full">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" for="bol_rif_ddt">
                    {{ __('Rif. DDT') }}
                </label>
                <input id="bol_rif_ddt" v-model="d.rif_ddt" type="text" maxlength="20" v-tracciato="'DKRMI'"
                    :class="{'bg-red-400': !d.rif_ddt && inviato}"
                    class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
            </div>
            <!-- Segnacollo del mittente: dato solo informativo. In AS400 va nel campo
                 DKUX2, posizione relativa 17, lunghezza 40 (quello che il tracciato chiama
                 email/sms): decisione di Michele del 22/09/2026. -->
            <div class="md:w-1/4 px-3 my-1 w-full">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" for="bol_segnacollo">
                    {{ __('Segnacollo mittente') }}
                </label>
                <input id="bol_segnacollo" v-model="d.segnacollo_mittente" type="text" maxlength="40" v-tracciato="'UX2_SEGNA'"
                    class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
            </div>
            <!-- 22/10/2026 (Michele): data della LDV, oggi o il giorno lavorativo dopo
                 (calendario AS400). Alla trasmissione una data ormai passata diventa oggi.
                 Accanto al segnacollo mittente (Michele); il numero della bozza resta sotto. -->
            <div class="md:w-1/4 px-3 my-1 w-full">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1"
                    for="bol_data_ldv">
                    {{ __('Data LDV') }}
                </label>
                <select id="bol_data_ldv" v-model="d.data_ldv" :disabled="giorniLdv.length === 0"
                    class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                    <option v-for="g in giorniLdv" :key="g" :value="g">{{ etichettaGiorno(g) }}</option>
                </select>
                <span v-if="d.numeratore" class="text-xs text-gray-500">
                    {{ __('Numero') }}: <span class="font-bold">{{ d.numeratore }}</span>
                </span>
            </div>
        </div>

        <!-- ==================================================== DESTINATARIO -->
        <div class="flex flex-wrap mt-2">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mx-2 my-1">
                {{ __('Destinatario') }}
            </label>
        </div>
        <div class="bg-transparent border p-2 border-gray-500 rounded">
            <!-- tipor="c": rubrica dedicata alla bollettazione. Nei ritiri ('a' e 'b')
                 non tutti i campi sono obbligatori e in rubrica ci sono voci con la sola
                 localita'; qui ragione sociale, indirizzo, CAP, localita' e provincia
                 servono tutti, quindi le due rubriche restano separate. -->
            <RagioneSocialeLocalitaSelect ref="dest" tipor="c" titolo-descrizione="Nome o ragione sociale" :auto_complete="destAutoComplete" :data="dest"
                :extra-rubrica="{ RIF_DEST: d.rif_destinatario, EMAIL: d.avviso, NOTE_DEST: d.dest_note }"
                @rubrica-caricata="caricaExtraRubrica"
                :resend="inviato" :refs="{
                    DESCRIZIONE: 'BOL_DES',
                    INDIRIZZO: 'BOL_IND',
                    OFLOC: 'BOL_LOC',
                    OFCPD: 'BOL_PRV',
                    OFCAP: 'BOL_CAP'
                }" @chosen="(v) => { dest = v; }" @notify="(s, m) => $emit('notify', s, m)"
                @setLoading="(f) => $emit('setLoading', f)">
            </RagioneSocialeLocalitaSelect>

            <div class="flex flex-wrap mt-2">
                <!-- "Ragione sociale - seconda riga" e "Indirizzo - seconda riga" TOLTI:
                     nel tracciato verso AS400 non esiste un posto dove metterli, quindi
                     il cliente li compilerebbe e non arriverebbero da nessuna parte.
                     Le colonne dest_ragsoc_ext / dest_indirizzo_ext restano in tabella
                     con il valore vuoto: se un giorno il tracciato avra' la seconda riga,
                     bastera' rimettere i due campi qui. -->
                <div class="md:w-1/2 px-3 my-1 w-full">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" for="bol_rif_dest">
                        {{ __('Riferimento destinatario') }}
                    </label>
                    <input id="bol_rif_dest" v-model="d.rif_destinatario" type="text" maxlength="40" v-tracciato="'DKRDE'"
                        class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                </div>
                <div class="md:w-1/2 px-3 my-1 w-full">
                    <!-- In AS400 DKERD + DKEID, i campi "estensione" del destinatario, usati
                         come un unico campo da 60 per le email a cui il tracking manda in
                         automatico l'avviso (decisione di Michele del 22/09/2026). -->
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" for="bol_avviso">
                        {{ __('Email destinatario per avviso tracking') }}
                    </label>
                    <input id="bol_avviso" v-model="d.avviso" type="text" maxlength="60" v-tracciato="'DK_EMAIL'"
                        class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                </div>
                <!-- 13/10/2026: note del destinatario (es. orari di ricezione). Si salvano in
                     rubrica con il destinatario; in AS400 non c'e' un campo: vanno nelle note
                     dopo ZTL e tipo di incasso (notaPrefisso / notaCompleta). -->
                <div class="md:w-1/2 px-3 my-1 w-full">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" for="bol_dest_note">
                        {{ __('Note destinatario (es. orari di ricezione)') }}
                    </label>
                    <input id="bol_dest_note" v-model="d.dest_note" type="text" maxlength="20"
                        class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                </div>
            </div>
        </div>

        <!-- ========================================================== MERCE -->
        <div class="flex flex-wrap mt-2">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mx-2 my-1">
                {{ __('Merce') }}
            </label>
        </div>
        <div class="bg-transparent border p-2 border-gray-500 rounded">
            <div class="flex flex-wrap">
                <div class="md:w-1/5 px-3 my-1 w-full">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" for="bol_colli">
                        {{ __('Colli') }}
                    </label>
                    <input id="bol_colli" v-model="d.colli" type="text" v-tracciato="'DKCOL'"
                        :class="{'bg-red-400': erroriMerce.colli}"
                        class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                </div>
                <div class="md:w-1/5 px-3 my-1 w-full">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" for="bol_bancali">
                        {{ __('Bancali a terra') }}
                    </label>
                    <input id="bol_bancali" v-model="d.bancali_a_terra" type="text" v-tracciato="'DKBAN'"
                        @change="allineaRighe"
                        class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                </div>
                <!-- EPAL, non EPAL e sfusi sono pezzi del campo DKUTL (posizioni relative
                     40-44, 35-39 e 28-32). Nel tracciato caricato DKUTL e' spezzato nei
                     suoi pezzi, quindi ognuno ha la sua regola: UTL_EPAL, UTL_NOEPA, UTL_SFUSI. -->
                <div class="md:w-1/5 px-3 my-1 w-full">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" for="bol_epal">
                        {{ __('Di cui EPAL') }}
                    </label>
                    <input id="bol_epal" v-model="d.epal" type="text" v-tracciato="'UTL_EPAL'"
                        :class="{'bg-red-400': erroriMerce.epal}"
                        class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                </div>
                <div class="md:w-1/5 px-3 my-1 w-full">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" for="bol_non_epal">
                        {{ __('Di cui non EPAL') }}
                    </label>
                    <input id="bol_non_epal" v-model="d.non_epal" type="text" v-tracciato="'UTL_NOEPA'"
                        :class="{'bg-red-400': erroriMerce.epal}"
                        class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                </div>
                <div class="md:w-1/5 px-3 my-1 w-full">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" for="bol_sfusi">
                        {{ __('Sfusi') }}
                    </label>
                    <input id="bol_sfusi" v-model="d.sfusi" type="text" v-tracciato="'UTL_SFUSI'"
                        :class="{'bg-red-400': erroriMerce.sfusi}"
                        class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                </div>
            </div>

            <div class="flex flex-wrap" v-if="daInput(d.sfusi) > 0">
                <div class="md:w-1/5 px-3 my-1 w-full">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1"
                        for="bol_peso_sfusi">
                        {{ __('Peso totale sfusi (kg)') }}
                    </label>
                    <input id="bol_peso_sfusi" v-model="d.peso_sfusi" type="text" v-tracciato="'DKPES'"
                        :class="{'bg-red-400': erroriMerce.pesoSfusi}"
                        class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                </div>
                <div class="md:w-1/5 px-3 my-1 w-full">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1"
                        for="bol_volume_sfusi">
                        {{ __('Volume totale sfusi (m³)') }}
                    </label>
                    <input id="bol_volume_sfusi" v-model="d.volume_sfusi" type="text" v-tracciato="'DKVOL'"
                        :class="{'bg-red-400': erroriMerce.volumeSfusi}"
                        class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                </div>
            </div>
        </div>

        <!-- =============================================== DETTAGLIO BANCALI -->
        <div class="flex flex-wrap mt-2 items-center">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mx-2 my-1">
                {{ __('Dettaglio bancali') }}
            </label>
            <span class="text-xs text-gray-500">
                {{ __('una riga per bancale') }} — {{ righe.length }} / {{ d.bancali_a_terra || 0 }}
            </span>
        </div>
        <div class="bg-transparent border p-2 border-gray-500 rounded"
            :class="{'border-red-400': erroriMerce.righe}">

            <div class="w-full overflow-x-auto">
                <table class="min-w-full text-xs">
                    <thead>
                        <tr class="text-left text-gray-700 uppercase font-bold">
                            <th class="px-2 py-1">#</th>
                            <th class="px-2 py-1">{{ __('Lungh. cm') }}</th>
                            <th class="px-2 py-1">{{ __('Largh. cm') }}</th>
                            <th class="px-2 py-1">{{ __('Alt. cm') }}</th>
                            <th class="px-2 py-1">{{ __('Peso kg') }}</th>
                            <th class="px-2 py-1">{{ __('Cod. merce') }}</th>
                            <th class="px-2 py-1">{{ __('Volume m³') }}</th>
                            <th class="px-2 py-1"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(r, i) in righe" :key="i" class="border-t border-gray-200">
                            <td class="px-2 py-1">{{ i + 1 }}</td>
                            <td class="px-2 py-1">
                                <input v-model="r.lunghezza_cm" type="text" v-tracciato="'DKLUN'"
                                    class="w-20 bg-gray-200 border border-gray-200 rounded px-2 py-1 focus:outline-none focus:bg-white">
                            </td>
                            <td class="px-2 py-1">
                                <input v-model="r.larghezza_cm" type="text" v-tracciato="'DKLAR'"
                                    class="w-20 bg-gray-200 border border-gray-200 rounded px-2 py-1 focus:outline-none focus:bg-white">
                            </td>
                            <td class="px-2 py-1">
                                <input v-model="r.altezza_cm" type="text" v-tracciato="'DKALT'"
                                    class="w-20 bg-gray-200 border border-gray-200 rounded px-2 py-1 focus:outline-none focus:bg-white">
                            </td>
                            <td class="px-2 py-1">
                                <input v-model="r.peso" type="text" v-tracciato="'DKPES'"
                                    class="w-24 bg-gray-200 border border-gray-200 rounded px-2 py-1 focus:outline-none focus:bg-white">
                            </td>
                            <td class="px-2 py-1 font-bold"
                                :class="codiceMerce(r) ? 'text-gray-800' : 'text-red-600'">
                                {{ codiceMerce(r) || __('fuori formato') }}
                            </td>
                            <td class="px-2 py-1">{{ formatoIt(volumeRiga(r), 2) }}</td>
                            <td class="px-2 py-1">
                                <button type="button" @click="duplicaRiga(i)"
                                    class="text-red-600 hover:bg-red-50 text-xl font-bold leading-none px-2 py-1 rounded mr-1"
                                    :title="__('duplica')">+</button>
                                <button type="button" @click="rimuoviRiga(i)"
                                    class="text-red-600 hover:bg-red-50 text-2xl font-bold leading-none px-2 py-1 rounded"
                                    :title="__('elimina')">&times;</button>
                            </td>
                        </tr>
                        <tr v-if="righe.length === 0">
                            <td colspan="8" class="px-2 py-3 text-gray-500">
                                {{ __('Nessun bancale. Indica i bancali a terra qui sopra, oppure spedisci solo sfusi.') }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="flex flex-wrap items-center mt-2">
                <button type="button" @click="aggiungiRiga"
                    class="bg-white border border-red-600 text-red-600 hover:bg-red-50 text-xs font-bold py-2 px-4 rounded mr-3">
                    {{ __('aggiungi bancale') }}
                </button>
                <input v-model.number="duplicaN" type="number" min="1" step="1"
                    class="w-16 text-xs bg-gray-200 border border-gray-200 rounded px-2 py-2 mr-2">
                <button type="button" @click="duplicaUltima"
                    class="bg-gray-300 hover:bg-gray-400 text-gray-800 text-xs font-bold py-2 px-4 rounded">
                    {{ __('duplica ultima riga × N') }}
                </button>
            </div>
        </div>

        <!-- ========================================================= TOTALI -->
        <div class="flex flex-wrap mt-2 bg-gray-100 rounded p-2">
            <div class="md:w-1/4 px-3 w-full">
                <span class="block uppercase text-gray-700 text-xs font-bold">{{ __('Peso totale') }}</span>
                <span class="text-sm">{{ formatoIt(pesoTotale, 2) }} kg</span>
            </div>
            <div class="md:w-1/4 px-3 w-full">
                <span class="block uppercase text-gray-700 text-xs font-bold">{{ __('Volume totale') }}</span>
                <span class="text-sm">{{ formatoIt(volumeTotale, 2) }} m³</span>
            </div>
            <div class="md:w-1/2 px-3 w-full">
                <span class="block uppercase text-gray-700 text-xs font-bold">{{ __('Merce lunga') }}</span>
                <span class="text-sm">
                    {{ merceLunga ? __('sì — una misura supera 300 cm')
                                  : (d.srv_merce_lunga ? __('sì — dichiarata') : __('no')) }}
                </span>
            </div>
        </div>

        <!-- ======================================== CONTRASSEGNO E CONSEGNA -->
        <div class="flex flex-wrap mt-2">
            <div class="md:w-1/4 px-3 my-1 w-full">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1"
                    for="bol_contrassegno">
                    {{ __('Contrassegno (EUR)') }}
                </label>
                <input id="bol_contrassegno" v-model="d.contrassegno" type="text" v-tracciato="'DKIF1'"
                    class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
            </div>
            <!-- Tipo di incasso: compare e diventa obbligatorio solo con il contrassegno.
                 Non ha un campo in AS400: va in testa alle note (30/09/2026). -->
            <div v-if="conContrassegno" class="md:w-1/4 px-3 my-1 w-full">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1"
                    for="bol_tipo_incasso">
                    {{ __('Tipo incasso') }}
                </label>
                <!-- Stesso elenco di BollettazioneTracciatoService::TIPI_INCASSO: il valore
                     e' il codice salvato (max 10), nelle note va TESTI_INCASSO. -->
                <select id="bol_tipo_incasso" v-model="d.tipo_incasso"
                    :class="{'bg-red-400': (inviato && !d.tipo_incasso) || contantiOltreLimite}"
                    class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                    <option value="">{{ __('-- scegli --') }}</option>
                    <option value="CONTANTI">{{ __('Contanti') }}</option>
                    <option value="ASS BANC">{{ __('Assegno bancario') }}</option>
                    <option value="ASS CIRC">{{ __('Assegno circolare') }}</option>
                    <option value="ASSB RILAS">{{ __('Assegno bancario come rilasciato') }}</option>
                </select>
                <span v-if="contantiOltreLimite" class="text-xs text-red-600">
                    {{ __('In contanti al massimo 4.999,99 €') }}
                </span>
            </div>
            <div class="md:w-1/4 px-3 my-1 w-full">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1"
                    for="bol_data_consegna">
                    {{ __('Data consegna') }}
                </label>
                <!-- min = DOMANI: una consegna non puo' essere chiesta per oggi o per
                     un giorno passato. max = 30 giorni (regola di Michele). Ferma anche l'anno assurdo,
                     perche' nel campo anno il browser accetta anche sei cifre e
                     "17/09/202222" passerebbe il controllo del minimo senza problemi. -->
                <input id="bol_data_consegna" v-model="d.data_consegna" type="date"
                    :min="minConsegna" :max="maxConsegna"
                    :class="{'bg-red-400 focus:bg-red-400': erroreData}"
                    class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                <!-- Il campo <input type="date"> non sa togliere i giorni dal calendario:
                     il sabato e la domenica si possono scegliere lo stesso. Qui si dice
                     perche' il campo e' diventato rosso, invece di lasciarlo rosso e basta. -->
                <p v-if="messaggioData" class="text-xs text-red-600 mt-1">{{ messaggioData }}</p>
            </div>
            <div class="md:w-1/4 px-3 my-1 w-full">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1"
                    for="bol_tipo_consegna">
                    {{ __('Tipo consegna') }}
                </label>
                <select id="bol_tipo_consegna" v-model="d.tipo_consegna"
                    class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                    <option value="">{{ __('prevista') }}</option>
                    <option value="1">{{ __('tassativa') }}</option>
                    <option value="3">{{ __('entro il') }}</option>
                    <option value="4">{{ __('a partire dal') }}</option>
                </select>
            </div>
            <div class="md:w-1/4 px-3 my-1 w-full">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1"
                    for="bol_giorno_chiusura">
                    {{ __('Giorno di chiusura') }}
                </label>
                <select id="bol_giorno_chiusura" v-model="d.giorno_chiusura"
                    class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                    <option value="">{{ __('nessuno') }}</option>
                    <option v-for="g in giorni" :key="g" :value="g">{{ g }}</option>
                </select>
            </div>
            <div class="md:w-1/4 px-3 my-1 w-full" v-if="d.giorno_chiusura">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" for="bol_test_chiusura">
                    {{ __('Chiuso') }}
                </label>
                <select id="bol_test_chiusura" v-model="d.test_chiusura"
                    class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                    <option value="">{{ __('-- scegli --') }}</option>
                    <option value="1">{{ __('mattina') }}</option>
                    <option value="2">{{ __('pomeriggio') }}</option>
                    <option value="3">{{ __('tutto il giorno') }}</option>
                </select>
            </div>
            <div class="w-full px-3 my-2">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" for="bol_note">
                    {{ __('Note') }}
                </label>
                <textarea id="bol_note" v-model="d.note" rows="2"
                    :class="{'bg-red-400': noteTroppoLunghe}"
                    class="text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"></textarea>
                <span class="text-xs" :class="noteTroppoLunghe ? 'text-red-600 font-bold' : 'text-gray-500'">
                    {{ (d.note || '').length }}/{{ maxNote }}
                </span>
                <span v-if="notaPrefisso" class="text-xs text-gray-500 ml-2">
                    {{ __('in testa alle note andrà:') }} <b>{{ notaPrefisso }}</b>
                </span>
            </div>
        </div>

        <!-- ======================================================= SERVIZI -->
        <div class="flex flex-wrap mt-2 px-3">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0 mr-4">
                {{ __('Servizi accessori') }}
            </label>
            <!-- Con il contrassegno la prenotazione telefonica e' obbligatoria (Michele,
                 01/10/2026): spuntata e bloccata. Lo impone anche il server. -->
            <label class="text-xs mr-6 my-1" :class="{'text-gray-500': conContrassegno}"
                :title="conContrassegno ? __('obbligatoria con il contrassegno') : ''">
                <input type="checkbox" v-model="d.appuntamento" :disabled="conContrassegno" class="mr-1">{{ __('Prenotazione Telefonica') }}<span v-if="conContrassegno"> {{ __('(obbligatoria con contrassegno)') }}</span>
            </label>
            <label class="text-xs mr-6 my-1"><input type="checkbox" v-model="d.srv_facchinaggio" class="mr-1">{{ __('Facchinaggio') }}</label>
            <label class="text-xs mr-6 my-1"><input type="checkbox" v-model="d.srv_adr" class="mr-1">{{ __('Merce ADR') }}</label>
            <label class="text-xs mr-6 my-1"><input type="checkbox" v-model="d.srv_gdo" class="mr-1">{{ __('Consegna GDO') }}</label>
            <label class="text-xs mr-6 my-1"><input type="checkbox" v-model="d.srv_ztl" class="mr-1">{{ __('Consegna in ZTL') }}</label>
            <label class="text-xs mr-6 my-1"><input type="checkbox" v-model="d.srv_piani" class="mr-1">{{ __('Consegna ai piani') }}</label>
            <label class="text-xs mr-6 my-1"><input type="checkbox" v-model="d.srv_sponda" class="mr-1">{{ __('Sponda idraulica') }}</label>
            <label class="text-xs mr-6 my-1"><input type="checkbox" v-model="d.srv_privati" class="mr-1">{{ __('Consegna a privati') }}</label>
            <label class="text-xs mr-6 my-1"><input type="checkbox" v-model="d.srv_espresso" class="mr-1">{{ __('Espresso') }}</label>
            <!-- Merce lunga (01/10/2026): automatica se un bancale supera 300 cm (spuntata e
                 bloccata), altrimenti il cliente la puo' dichiarare a mano - per esempio
                 uno sfuso lungo, che non ha misure. -->
            <label class="text-xs mr-6 my-1" :class="{'text-gray-500': merceLunga}">
                <input type="checkbox" v-model="d.srv_merce_lunga" :disabled="merceLunga" class="mr-1">{{ __('Merce lunga') }}<span v-if="merceLunga"> {{ __('(automatica: una misura supera 300 cm)') }}</span>
            </label>
        </div>

        <!-- ======================================================= PULSANTI -->
        <div class="flex flex-wrap justify-between items-center mt-3 px-3 pb-2">
            <button type="button" @click="pulisci"
                class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded">
                {{ __('pulisci modulo') }}
            </button>
            <button type="submit"
                class="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
                {{ d.id ? __('salva modifiche') : __('salva bozza') }}
            </button>
        </div>
    </form>
</template>

<script>
import RagioneSocialeLocalitaSelect from './utility/RagioneSocialeLocalitaSelect.vue';

/** Chiave della copia del modulo nel sessionStorage (vedi watch). */
const CHIAVE_MODULO = 'bol_modulo_in_corso';

/** Codice del tipo di incasso => scritta nelle note. Uguale a BollettazioneTracciatoService::TIPI_INCASSO. */
const TESTI_INCASSO = {
    'CONTANTI': 'CONTANTI',
    'ASS BANC': 'ASSEGNO BANCARIO',
    'ASS CIRC': 'ASSEGNO CIRCOLARE',
    'ASSB RILAS': 'ASSEGNO COME RILASCIATO'
};

/**
 * Modulo di creazione/modifica di una richiesta di bollettazione.
 *
 * Il codice merce e i totali mostrati qui sono un'ANTICIPAZIONE: applicano la stessa
 * regola del server sugli stessi dati (bol_formati_pallex), ma il valore che finisce
 * in AS400 e' sempre quello ricalcolato dal server al salvataggio e alla conferma.
 * Se i due divergono, e' il server ad avere ragione: qui non si decide niente.
 */
export default {
    components: {
        RagioneSocialeLocalitaSelect
    },
    props: {
        contratti: {
            type: Array,
            default: () => []
        },
        formati: {
            type: Array,
            default: () => []
        },
        /**
         * I giorni in cui si puo' chiedere la consegna, AAAA-MM-GG, dal calendario
         * AS400: quelli lavorativi da domani a 30 giorni avanti. Se l'elenco non
         * arriva (elenco vuoto) il form NON blocca niente: ci pensa il server alla
         * conferma. Un dato che non c'e' non deve impedire di lavorare.
         */
        giorniLavorativi: {
            type: Array,
            default: () => []
        },
        /** 22/10/2026: giorni ammessi per la data LDV, AAAA-MM-GG (oggi o il lavorativo dopo). */
        giorniLdv: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            d: this.vuota(),
            dest: this.destVuoto(),
            destAutoComplete: this.autoCompleteVuoto(),
            righe: [],
            duplicaN: 1,
            inviato: false,
            moduloControllato: false,
            giorni: ['LUN', 'MAR', 'MER', 'GIO', 'VEN', 'SAB', 'DOM']
        }
    },
    created() {
        // Regole dei campi dai tracciati AS400 della bollettazione: testata NTDKTK e
        // dettaglio colli NTDKCO. Non si aspetta la risposta: la direttiva
        // v-tracciato decora i campi da sola quando le regole arrivano, e nel
        // frattempo il filtro lascia passare tutto come prima.
        this.caricaRegoleTracciato('NTDKTK');
        this.caricaRegoleTracciato('NTDKCO');
        this.recuperaModulo();
    },
    /**
     * Modulo conservato se la sessione scade (30/09/2026).
     *
     * Quando il token scade e il rinnovo non riesce si finisce sul login, e prima
     * tutto quello che era stato scritto andava perso. Ora ogni modifica viene
     * copiata nel sessionStorage della scheda; rientrati, la pagina la ripropone.
     *
     * sessionStorage e non localStorage: la copia muore con la scheda, quindi su un
     * PC condiviso non resta niente il giorno dopo. La copia porta il nome utente:
     * se nella stessa scheda entra un altro utente non la vede, e viene buttata.
     * Si cancella da sola quando il modulo torna vuoto (salva bozza, pulisci modulo).
     */
    watch: {
        d: { deep: true, handler() { this.ricordaModulo(); } },
        dest: { deep: true, handler() { this.ricordaModulo(); } },
        righe: { deep: true, handler() { this.ricordaModulo(); } },
        // contrassegno -> prenotazione telefonica obbligatoria (01/10/2026)
        conContrassegno(si) {
            if (si) this.d.appuntamento = true;
        },
        // un bancale oltre 300 cm -> merce lunga obbligatoria (01/10/2026)
        merceLunga(si) {
            if (si) this.d.srv_merce_lunga = true;
        },
        // 22/10/2026: l'elenco dei giorni LDV arriva dopo che il form e' montato
        giorniLdv() {
            this.allineaDataLdv();
        },
        // l'utente puo' arrivare dopo la creazione del modulo
        '$store.state.user'(u) {
            if (u && !this.moduloControllato) this.recuperaModulo();
        }
    },
    computed: {
        /**
         * Date calcolate al volo e non salvate in data(): una pagina lasciata aperta
         * fino a dopo mezzanotte continuerebbe ad accettare la data di ieri.
         */
        domani() {
            return this.giornoRelativo(1);
        },
        /** 22/10/2026: la consegna si chiede dal giorno dopo la data LDV (e mai prima di domani). */
        minConsegna() {
            const l = this.d.data_ldv;
            if (l && /^\d{4}-\d{2}-\d{2}$/.test(l) && l >= this.domani) {
                return this.giornoDopo(l);
            }
            return this.domani;
        },
        /** Una consegna si chiede al massimo 30 giorni avanti: regola di Michele. */
        maxConsegna() {
            return this.giornoRelativo(30);
        },
        /**
         * Sabato o domenica. Il campo date non sa escludere giorni della settimana,
         * quindi il controllo si fa qui - e comunque anche sul server, perche' il
         * controllo del browser lo salta chiunque voglia saltarlo.
         * 'T00:00:00' ci vuole: new Date('2026-09-26') legge la data come UTC e in
         * Italia diventa il giorno prima, cioe' il venerdi'.
         */
        dataWeekend() {
            const v = this.d.data_consegna;
            if (!v || !/^\d{4}-\d{2}-\d{2}$/.test(v)) return false;
            const g = new Date(v + 'T00:00:00').getDay();   // 0 domenica, 6 sabato
            return g === 0 || g === 6;
        },
        /**
         * Giorno che il calendario AS400 non da' per lavorativo: feste comprese.
         * Sabato e domenica li prende gia' dataWeekend, ma questo li ripesca lo stesso
         * se il calendario li marca festivi, ed e' giusto cosi': la fonte e' una sola.
         */
        giornoNonLavorativo() {
            const v = this.d.data_consegna;
            if (!v || !/^\d{4}-\d{2}-\d{2}$/.test(v)) return false;
            if (this.giorniLavorativi.length === 0) return false;   // elenco non arrivato
            // L'elenco va da DOMANI a 30 giorni: fuori da li' non dice niente, e dare
            // del "non lavorativo" a una data semplicemente passata e' un messaggio
            // sbagliato. Ci pensa messaggioData, che quel caso lo chiama col suo nome.
            if (v < this.domani || v > this.maxConsegna) return false;
            return !this.giorniLavorativi.includes(v);
        },
        /**
         * PERCHE' la data non va bene, in parole. Vuoto = va bene (o non c'e': la data
         * non e' obbligatoria).
         *
         * Sta tutto qui apposta: prima il campo diventava rosso e il motivo lo diceva
         * solo in due casi su quattro. Un campo rosso senza spiegazione, su una bozza
         * riaperta, e' esattamente il momento in cui il cliente telefona.
         *
         * L'ordine conta: si dice la cosa piu' vicina al perche' - una data passata e'
         * passata, non "non lavorativa".
         */
        messaggioData() {
            const v = this.d.data_consegna;
            if (!v) return '';
            // il campo date restituisce AAAA-MM-GG, ma il browser accetta anche un anno
            // di sei cifre: '202222-09-17' arriverebbe fin qui
            if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) return this.__('Data non valida');
            if (v < this.domani) return this.__('La consegna si chiede da domani in poi');
            if (v < this.minConsegna) return this.__('La consegna va dopo la data LDV');
            if (v > this.maxConsegna) return this.__('Al massimo 30 giorni da oggi');
            if (this.dataWeekend) return this.__('Consegne dal lunedì al venerdì');
            if (this.giornoNonLavorativo) return this.__('Giorno non lavorativo: scegline un altro');
            return '';
        },
        /** Il campo e' rosso se e solo se c'e' un motivo scritto sotto. */
        erroreData() {
            return this.messaggioData !== '';
        },
        conContrassegno() {
            return this.daInput(this.d.contrassegno) > 0;
        },
        /** Stesso limite di BollettazioneService::LIMITE_CONTANTI (4.999,99). */
        contantiOltreLimite() {
            return this.conContrassegno && this.d.tipo_incasso === 'CONTANTI'
                && this.daInput(this.d.contrassegno) > 4999.99;
        },
        /**
         * Quello che il server scrive in testa alle note: stessa regola di
         * BollettazioneTracciatoService::notaCompleta(). Se cambia la', cambia qui.
         */
        notaPrefisso() {
            const parti = [];
            if (this.d.srv_ztl) parti.push('ZTL');
            const tipo = (this.d.tipo_incasso || '').trim();
            if (this.conContrassegno && tipo) parti.push(TESTI_INCASSO[tipo] || tipo);
            const noteDest = (this.d.dest_note || '').trim().toUpperCase();
            if (noteDest) parti.push(noteDest);
            return parti.join(' - ');
        },
        /** Note in AS400: 100 caratteri in tutto, il prefisso li consuma. */
        maxNote() {
            return this.notaPrefisso ? 100 - this.notaPrefisso.length - 3 : 100;
        },
        noteTroppoLunghe() {
            return (this.d.note || '').trim().length > this.maxNote;
        },
        pesoTotale() {
            let p = this.daInput(this.d.peso_sfusi);
            this.righe.forEach(r => { p += this.daInput(r.peso); });
            return Math.round(p * 100) / 100;
        },
        volumeTotale() {
            let v = this.daInput(this.d.volume_sfusi);
            this.righe.forEach(r => { v += this.volumeRiga(r); });
            return Math.round(v * 100) / 100;
        },
        merceLunga() {
            return this.righe.some(r => Math.max(
                this.daInput(r.lunghezza_cm),
                this.daInput(r.larghezza_cm),
                this.daInput(r.altezza_cm)) > 300);
        },
        /** Evidenziazione dei campi incoerenti, solo dopo il primo tentativo di invio. */
        erroriMerce() {
            if (!this.inviato) return {};
            const colli = this.daInput(this.d.colli);
            const bancali = this.daInput(this.d.bancali_a_terra);
            const sfusi = this.daInput(this.d.sfusi);
            return {
                colli: colli <= 0 || colli < bancali + sfusi,
                epal: bancali > 0 && (this.daInput(this.d.epal) + this.daInput(this.d.non_epal)) < bancali,
                sfusi: bancali === 0 && sfusi <= 0,
                pesoSfusi: sfusi > 0 && !(this.daInput(this.d.peso_sfusi) > 0),
                volumeSfusi: sfusi > 0 && !(this.daInput(this.d.volume_sfusi) > 0),
                righe: bancali > 0
                    ? this.righe.length !== bancali || this.righe.some(r => !this.codiceMerce(r))
                    : this.righe.length > 0
            };
        }
    },
    methods: {
        /**
         * Data di oggi + N giorni, in AAAA-MM-GG e nel fuso LOCALE.
         *
         * Non si usa toISOString(): quella restituisce l'ora UTC, e in Italia
         * d'estate fra mezzanotte e le due darebbe il giorno prima. Un cliente che
         * prenota a tarda sera si vedrebbe rifiutare una data valida.
         */
        /** 22/10/2026: il giorno dopo una data AAAA-MM-GG, nel fuso locale. */
        giornoDopo(data) {
            const g = new Date(data + 'T00:00:00');
            g.setDate(g.getDate() + 1);
            const mm = String(g.getMonth() + 1).padStart(2, '0');
            const gg = String(g.getDate()).padStart(2, '0');
            return g.getFullYear() + '-' + mm + '-' + gg;
        },
        /** "oggi 22/10" oppure "ven 23/10" per la tendina della data LDV. */
        etichettaGiorno(data) {
            const p = data.split('-');
            const breve = p[2] + '/' + p[1];
            if (data === this.giornoRelativo(0)) return this.__('oggi') + ' ' + breve;
            const nomi = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];
            return this.__(nomi[new Date(data + 'T00:00:00').getDay()]) + ' ' + breve;
        },
        /** La data LDV deve essere una di quelle ammesse: se no (vuota, o bozza di ieri) la prima. */
        allineaDataLdv() {
            if (this.giorniLdv.length === 0) return;
            if (!this.giorniLdv.includes(this.d.data_ldv)) {
                this.d.data_ldv = this.giorniLdv[0];
            }
        },
        giornoRelativo(giorni) {
            const g = new Date();
            g.setDate(g.getDate() + giorni);
            const mm = String(g.getMonth() + 1).padStart(2, '0');
            const gg = String(g.getDate()).padStart(2, '0');
            return g.getFullYear() + '-' + mm + '-' + gg;
        },
        vuota() {
            return {
                id: null,
                numeratore: null,
                contratto: '',
                rif_ddt: '',
                rif_destinatario: '',
                avviso: '',
                dest_note: '',
                segnacollo_mittente: '',
                colli: null,
                bancali_a_terra: null,
                epal: null,
                non_epal: null,
                sfusi: null,
                peso_sfusi: null,
                volume_sfusi: null,
                contrassegno: null,
                tipo_incasso: '',
                note: '',
                data_consegna: null,
                data_ldv: null,
                tipo_consegna: '',
                appuntamento: false,
                giorno_chiusura: '',
                test_chiusura: '',
                srv_piani: false,
                srv_sponda: false,
                srv_privati: false,
                srv_espresso: false,
                srv_facchinaggio: false,
                srv_adr: false,
                srv_gdo: false,
                srv_ztl: false,
                srv_merce_lunga: false
            };
        },
        /**
         * Destinatario preso dalla rubrica: riferimento ed email sono suoi (07/10/2026).
         * Una voce salvata prima non li ha: si svuotano, altrimenti resterebbero
         * quelli del destinatario precedente.
         */
        caricaExtraRubrica(ritiro) {
            this.d.rif_destinatario = (ritiro && ritiro.rif_destinatario) || '';
            this.d.avviso = (ritiro && ritiro.email) || '';
            this.d.dest_note = (ritiro && ritiro.note_destinatario) || '';
        },
        destVuoto() {
            return { DESCRIZIONE: '', INDIRIZZO: '', OFCAP: '', OFLOC: '', OFCPD: '' };
        },
        autoCompleteVuoto() {
            return {
                OFCAP: { text: '', selectedOption: [] },
                OFLOC: { text: '', selectedOption: [] },
                OFCPD: { selectedOption: [] }
            };
        },

        // ------------------------------------------------- modulo conservato
        utenteModulo() {
            const u = this.$store.state.user;
            return u ? String(u.username || u.id || '') : '';
        },
        /** Vuoto = nessun valore compilato (0, '' e false contano come vuoti). */
        moduloVuoto() {
            // 22/10/2026: data_ldv non conta, la mette il modulo da solo (sempre piena)
            return Object.keys(this.d).every(k => k === 'data_ldv' || !this.d[k])
                && Object.values(this.dest).every(v => !v)
                && this.righe.length === 0;
        },
        ricordaModulo() {
            if (!this.moduloControllato) return;
            const utente = this.utenteModulo();
            // durante il logout l'utente non c'e' piu': si tiene l'ultima copia buona
            if (!utente) return;
            try {
                if (this.moduloVuoto()) {
                    sessionStorage.removeItem(CHIAVE_MODULO);
                    return;
                }
                sessionStorage.setItem(CHIAVE_MODULO, JSON.stringify({
                    utente: utente, d: this.d, dest: this.dest, righe: this.righe
                }));
            } catch (e) {
                // storage pieno o negato dal browser: si lavora come prima
            }
        },
        recuperaModulo() {
            const utente = this.utenteModulo();
            if (!utente) return;
            this.moduloControllato = true;
            let copia = null;
            try {
                copia = JSON.parse(sessionStorage.getItem(CHIAVE_MODULO) || 'null');
            } catch (e) {
                copia = null;
            }
            if (!copia || !copia.d) return;
            if (copia.utente !== utente) {
                try { sessionStorage.removeItem(CHIAVE_MODULO); } catch (e) { /* niente */ }
                return;
            }
            Object.keys(this.d).forEach(k => {
                if (copia.d[k] !== undefined) this.d[k] = copia.d[k];
            });
            this.dest = Object.assign(this.destVuoto(), copia.dest || {});
            this.destAutoComplete = {
                OFCAP: { text: this.dest.OFCAP || '', selectedOption: [] },
                OFLOC: { text: this.dest.OFLOC || '', selectedOption: [] },
                OFCPD: { selectedOption: [] }
            };
            this.righe = Array.isArray(copia.righe) ? copia.righe : [];
            this.allineaDataLdv();   // la copia puo' essere di ieri
            this.$emit('notify', true, this.__('Ho ripreso i dati che stavi inserendo'));
        },

        // ------------------------------------------------- codice merce e volume
        /**
         * Stessa regola del server: vince il PRIMO formato che contiene tutte e
         * quattro le grandezze. I formati arrivano gia' ordinati per numero PALLEX.
         */
        codiceMerce(r) {
            const l = this.daInput(r.lunghezza_cm);
            const w = this.daInput(r.larghezza_cm);
            const h = this.daInput(r.altezza_cm);
            const p = this.daInput(r.peso);
            if (l <= 0 || w <= 0 || h <= 0 || p <= 0) return null;
            const f = this.formati.find(f =>
                l >= f.lung_min && l <= f.lung_max &&
                w >= f.larg_min && w <= f.larg_max &&
                h >= f.alt_min && h <= f.alt_max &&
                p >= Number(f.peso_min) && p <= Number(f.peso_max));
            return f ? f.codice : null;
        },
        /** m³ arrotondati PER ECCESSO a 2 decimali, riga per riga come sul server. */
        volumeRiga(r) {
            const mc = (this.daInput(r.lunghezza_cm) * this.daInput(r.larghezza_cm) *
                this.daInput(r.altezza_cm)) / 1000000;
            return Math.ceil(mc * 100) / 100;
        },

        // ------------------------------------------------------- righe bancali
        rigaVuota() {
            return { lunghezza_cm: null, larghezza_cm: null, altezza_cm: null, peso: null };
        },
        aggiungiRiga() {
            this.righe.push(this.rigaVuota());
            this.sincronizzaBancali();
        },
        rimuoviRiga(i) {
            this.$delete(this.righe, i);
            this.sincronizzaBancali();
        },
        duplicaRiga(i) {
            this.righe.splice(i + 1, 0, Object.assign({}, this.righe[i]));
            this.sincronizzaBancali();
        },
        duplicaUltima() {
            if (this.righe.length === 0) {
                this.$emit('notify', false, this.__('Aggiungi prima un bancale da duplicare'));
                return;
            }
            const n = Math.max(1, Number(this.duplicaN) || 1);
            const ultima = this.righe[this.righe.length - 1];
            for (let k = 0; k < n; k++) this.righe.push(Object.assign({}, ultima));
            this.sincronizzaBancali();
        },
        /** Il numero di bancali a terra segue il dettaglio: un dato solo, non due. */
        sincronizzaBancali() {
            this.d.bancali_a_terra = this.righe.length;
        },
        /** Se il cliente cambia il numero a mano, allineo le righe (aggiungo/tolgo in coda). */
        allineaRighe() {
            const n = Math.max(0, this.daInput(this.d.bancali_a_terra));
            while (this.righe.length < n) this.righe.push(this.rigaVuota());
            while (this.righe.length > n) this.righe.pop();
        },

        // ------------------------------------------------------------ azioni
        pulisci() {
            this.d = this.vuota();
            this.dest = this.destVuoto();
            this.destAutoComplete = this.autoCompleteVuoto();
            this.righe = [];
            this.inviato = false;
            this.allineaDataLdv();
        },

        /** Riapre una bozza dall'elenco. Le confermate non arrivano qui. */
        caricaBozza(r) {
            this.pulisci();
            Object.keys(this.d).forEach(k => {
                if (r[k] !== undefined) this.d[k] = r[k];
            });
            // il server restituisce i numeri col punto: nei campi vanno con la virgola,
            // altrimenti il filtro del tracciato prenderebbe il punto per un separatore
            ['colli', 'bancali_a_terra', 'epal', 'non_epal', 'sfusi',
             'peso_sfusi', 'volume_sfusi', 'contrassegno'].forEach(k => {
                this.d[k] = this.perInput(this.d[k]);
            });
            this.d.id = r.id;
            // 22/10/2026: bozza di ieri o senza data LDV -> il primo giorno ammesso
            this.allineaDataLdv();
            this.dest = {
                DESCRIZIONE: r.dest_ragsoc || '',
                INDIRIZZO: r.dest_indirizzo || '',
                OFCAP: r.dest_cap || '',
                OFLOC: r.dest_localita || '',
                OFCPD: r.dest_provincia || ''
            };
            this.destAutoComplete = {
                OFCAP: { text: r.dest_cap || '', selectedOption: [] },
                OFLOC: { text: r.dest_localita || '', selectedOption: [] },
                // 08/10/2026: senza 'text' la provincia restava a video vuota riaprendo una
                // bozza (il valore c'era, in this.dest, ma il campo mostrava "...")
                OFCPD: { text: r.dest_provincia || '', selectedOption: [] }
            };
            this.righe = (r.bancali || []).map(b => ({
                lunghezza_cm: this.perInput(b.lunghezza_cm),
                larghezza_cm: this.perInput(b.larghezza_cm),
                altezza_cm: this.perInput(b.altezza_cm),
                peso: this.perInput(b.peso)
            }));
        },

        payload() {
            return Object.assign({}, this.d, {
                dest_ragsoc: this.dest.DESCRIZIONE,
                dest_indirizzo: this.dest.INDIRIZZO,
                dest_cap: this.dest.OFCAP,
                dest_localita: this.dest.OFLOC,
                dest_provincia: this.dest.OFCPD,
                bancali: this.righe
            });
        },

        async salva() {
            this.inviato = true;
            await this.storeLogTime(async () => {
                const res = await this.handleCallback(
                    () => this.axios.post(this.$store.getters.uri + '/bollettazione/salva', this.payload()),
                    false);
                if (res && res.id) {
                    this.$emit('notify', true, this.__('Bozza salvata'));
                    this.pulisci();
                    this.$emit('salvata', res);
                } else {
                    // salvataggio rifiutato: il cursore va sul primo campo rosso
                    this.vaiAlPrimoRosso();
                }
                return res;
            });
        }
    }
}
</script>
